import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';
import { SubscriptionPlans } from '../../../../../../../../shared/utils';

interface NotesListTabSkeletonProps {
  planCode?: string;
}

const NotesListTabSkeleton: React.FC<NotesListTabSkeletonProps> = ({
  planCode,
}) => (
  <div className="notes-list-tab-skeleton">
    <div className="notes-list-tab-editor-skeleton">
      <div className="notes-list-tab-editor-header-skeleton">
        <SkeletonLoading width={240} height={14} />
      </div>
      <div className="notes-list-tab-editor-footer-skeleton">
        <div className="notes-list-tab-editor-footer-left-skeleton">
          <SkeletonLoading width={32} height={32} circle />
          <SkeletonLoading width={32} height={32} circle />
        </div>
        <SkeletonLoading width={82} height={32} />
      </div>
    </div>
    {planCode !== SubscriptionPlans.FREE && (
      <div className="notes-search-skeleton">
        <SkeletonLoading width={16} height={16} />
        <SkeletonLoading width={69} height={14} />
      </div>
    )}
    {Array.from({ length: 3 }).map(() => (
      <div className="notes-list-tab-body-skeleton">
        <SkeletonLoading width={32} height={32} circle />
        <div className="notes-list-tab-body-content-skeleton">
          <SkeletonLoading width={123} height={18} />
          <SkeletonLoading width={454} height={14} />
          <SkeletonLoading width={388} height={14} />
          <SkeletonLoading width={240} height={14} />
        </div>
      </div>
    ))}
  </div>
);

export default NotesListTabSkeleton;
